import { applyHiddenMask } from '@/domain/models/data-format-pattern-model'
import DocumentFormatPattern from '@/domain/models/document-format-pattern-model'
import { IMask } from 'react-imask'
import PatternRegex from './pattern-regex'

interface CpfFormatter {
  textMask: (value: string | number) => string
}

const DocumentCpfFormatPattern: DocumentFormatPattern<string> & CpfFormatter = {
  normalize: (value: string) => PatternRegex.getOnlyNumbers(value),
  placeholder: '000.000.000-00',
  mask: '`a{.}`b{.}`c{-}`d',
  hiddenMask: '000.\\*\\*\\*.\\*\\*\\*-00',
  hide: (value: string) =>
    applyHiddenMask(
      value?.substring(0, 3) + value?.at(-2) + value?.at(-1),
      DocumentCpfFormatPattern.hiddenMask!
    ),
  blocks: {
    a: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 999,
      maxLength: 3
    },
    b: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 999,
      maxLength: 3
    },
    c: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 999,
      maxLength: 3
    },
    d: {
      mask: IMask.MaskedRange,
      from: 0,
      to: 99,
      maxLength: 2
    }
  },
  validate: (value?: string): boolean => {
    if (!value) return false

    const cleanCPF = PatternRegex.getOnlyNumbers(value)

    if (PatternRegex.isRepeatableNumbers(cleanCPF)) return false

    if (cleanCPF.length !== 11) return false

    const sum1 = cleanCPF
      .split('')
      .slice(0, 9)
      .reduce((sum, digit, index) => sum + parseInt(digit) * (10 - index), 0)
    const remainder1 = ((sum1 * 10) % 11) % 10

    if (remainder1 !== parseInt(cleanCPF.charAt(9))) return false

    const sum2 = cleanCPF
      .split('')
      .slice(0, 10)
      .reduce((sum, digit, index) => sum + parseInt(digit) * (11 - index), 0)
    const remainder2 = ((sum2 * 10) % 11) % 10

    if (remainder2 !== parseInt(cleanCPF.charAt(10))) return false

    return true
  },
  isValid: (value?: string): boolean => {
    return DocumentCpfFormatPattern.validate?.(value) === true
  },
  rules: {
    minLength: {
      value: 14,
      message: 'Insira exatos 14 caracteres neste campo'
    },
    maxLength: {
      value: 14,
      message: 'Insira exatos 14 caracteres neste campo'
    }
  },
  textMask: (value: string | number) => {
    if (!value) return ''

    value = String(value)
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d)/, '$1.$2')
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2')

    return value
  }
}

export default DocumentCpfFormatPattern
